// extracted by mini-css-extract-plugin
export var scrollArea = "_nh-0";